import { render, staticRenderFns } from "./billDrawer.vue?vue&type=template&id=4ff5a670&"
import script from "./billDrawer.vue?vue&type=script&lang=js&"
export * from "./billDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports